<script lang="ts">
  import Text from '$components/utils/Text.svelte';
</script>

<div class="support-us" id="darujte">
  <div class="support-us__text">
    <h2><Text key="page.club.support-us-text.heading" /></h2>
    <p><Text key="page.club.support-us-text.text" /></p>
  </div>
</div>

<style lang="scss">
  .support-us {
    width: 100%;
    height: fit-content;
    display: flex;
    align-items: center;
    flex-direction: column;
    &__text {
      margin-top: 149px;

      align-self: center;
      text-align: center;

      display: flex;
      align-items: center;
      flex-direction: column;

      width: 45%;
      max-width: 720px;

      h2 {
        font-weight: 700;
        font-size: 36px;
        line-height: 45px;
      }
      p {
        margin-top: 19px;

        font-weight: 500;
        font-size: 17px;
        line-height: 31px;
      }
    }
  }

  @include mobile {
    .support-us {
      scroll-margin-top: 40px;

      &__text {
        margin-top: 40px;
        width: 90%;

        h2 {
          font-size: 28px;

          width: 70%;
        }
        p {
          margin-top: 20px;
        }
      }
    }
  }
</style>
